import React, { useEffect, useMemo, useState } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { ErrorMessage, Spinner, LogoComp } from "../elements";
import CountUp from "react-countup";
import Confetti from "react-confetti";
import { AnalyticsEvent } from "../../components/elements/analytics-event";
import { useLocation, useSearchParams } from "react-router-dom";

const CHARITY_TYPE = {
  TILTIFY: "tiltify",
  TWITCH: "twitch",
};

const VerticalOverlay3D = ({ overlayStore }) => {
  //TODO use proper router hooks to get if twitch or tiltify

  //TODO use proper router hooks to get params instead of this useEffect daisy chain nonsense
  const [urlParams] = useSearchParams();
  const loc = useLocation();
  const pathParts = useMemo(
    () => loc.pathname.split("/").slice(1),
    [loc.pathname]
  );
  const overlay = pathParts[0];
  const username = pathParts[1];
  const isTwitch = username === CHARITY_TYPE.TWITCH;
  const slug = pathParts[2];

  const queryString = window.location.search;
  const findParam = (param) => {
    if (param) {
      const slug = window.location.pathname.split("/")[4].split("&");

      const paramValue = slug.filter((str) => {
        return str.includes(param);
      });

      if (paramValue.length > 0) {
        return paramValue[0].split("=")[1];
      }

      return null;
    }

    return null;
  };
  //const urlParams = new URLSearchParams(queryString);

  const bgColor = urlParams.get("bgColor")
    ? urlParams.get("bgColor")
    : findParam("bgColor");

  // const fake = urlParams.get("fake") ?? findParam("fake") ?? "no";

  const fake = urlParams.get("fake") ? urlParams.get("fake") : "no";

  useEffect(() => {
    if (!isTwitch) {
      /* Remove for production */
      const url = `${process.env.REACT_APP_LOCAL_URI}/vertical-3d/`;
      /* Remove for production */

      let streamer = window.location.href.replace(url, "").split("/");
      // Tiltify
      if (streamer[0][0] === "@" || streamer[0][0] === "+") {
        streamer[2] = streamer[0][0];
        streamer[0] = streamer[0].substr(1, streamer[0].length);
      } else {
        streamer[2] = "@";
      }

      if (streamer[0] !== "") {
        let streamType = streamer[2],
          username = streamer[0],
          slug = streamer[1];

        /* Remove for production */
        overlayStore.socketConnect(
          streamType,
          username,
          slug,
          null,
          fake === "yes"
        );

        return () => overlayStore.socketDisconnect();
      }
    } else {
      // Twitch

      const twitchOAuthToken = slug;

      overlayStore.twitchSocketConnect(twitchOAuthToken);

      return () => overlayStore.socketDisconnect();
    }
    //props.userStore.getAccessToken();
  }, []);

  /*  useEffect(() => {
    if (twitchParams) {
      const {  twitchOAuthToken } = twitchParams;

     
      if (initialSocketConnect) {
        overlayStore.twitchSocketConnect(twitchOAuthToken);
        setInitialSocketConnect(false);
      } 
    }
  }, [twitchParams, overlayStore.socket]); */

  // useEffect(() => {
  //   console.log("OVERLAY STORE SOCKET: ", overlayStore.socket);
  // }, [overlayStore.socket]);

  const {
    error,
    isLoading,
    cause,
    status,
    raised,
    goal,
    progress,
    streamType,
  } = overlayStore;
  //const { accessToken } = props.userStore;

  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    <div>
      {cause != `${process.env.REACT_APP_TILTIFY_CAUSE_ID}` &&
      cause != "St. Jude Children's Research Hospital" ? (
        <p className="unpublished">
          This campaign is unpublished, retired or not a valid St. Jude
          campaign.
        </p>
      ) : status == "published" ? (
        <div className="vertical-overlay-3d">
          <div className="cube_wrapper">
            <div
              className="percent_raised"
              style={{
                top: `${
                  progress < 10
                    ? 85
                    : progress >= 100
                    ? 100 - progress
                    : 95 - progress
                }%`,
              }}
            >
              $
              <CountUp
                end={raised}
                duration={1}
                separator=","
                decimals={raised - Math.floor(raised) !== 0 ? 2 : 0}
                preserveValue={true}
                useEasing={true}
              />
            </div>

            <div
              className="cube"
              style={{
                height: `${
                  progress < 10 ? 10 : progress >= 100 ? 95 : progress
                }%`,
              }}
            >
              <div className={"cube__top " + bgColor} />
              <div className={"cube__front " + bgColor}>
                <LogoComp plclass="hide" />
                {raised >= goal ? (
                  <div className="cube__front__completed">
                    <Confetti
                      width={130}
                      height={1080}
                      numberOfPieces={50}
                      gravity={0.3}
                      colors={[
                        "#8332a7",
                        "#1874dc",
                        "#64d0e4",
                        "#c0da07",
                        "#ffc32c",
                        "#490e67",
                        "#002856",
                        "#1eadc1",
                        "#75bc21",
                        "#ffb125",
                        "#c10f3a",
                      ]}
                    />
                    <div className="cube__front__goalmet">
                      <span>G</span>
                      <span>O</span>
                      <span>A</span>
                      <span>L</span>
                      <span className="completed_space">M</span>
                      <span>E</span>
                      <span>T</span>
                    </div>
                  </div>
                ) : (
                  <div className="cube__front__progress">
                    {progress >= 25 ? (
                      <div>
                        <div className="bar__one"></div>
                        <div className="bar__two"></div>
                        <div className="bar__three"></div>
                        <div className="bar__four"></div>

                        <div className="bar__five"></div>
                        <div className="bar__six"></div>
                        <div className="bar__seven"></div>
                        <div className="bar__eight"></div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="cube__front__progress__bg">
                      {progress >= 25 ? (
                        <CountUp
                          end={progress >= 10 ? progress : ""}
                          duration={1}
                          separator=","
                          decimals={0}
                          preserveValue={true}
                          useEasing={true}
                        />
                      ) : (
                        ""
                      )}
                      {progress >= 25 ? "%" : ""}
                    </div>
                    {progress >= 25 ? (
                      <CountUp
                        end={progress >= 25 ? progress : ""}
                        duration={1}
                        separator=","
                        decimals={0}
                        preserveValue={true}
                        useEasing={true}
                      />
                    ) : (
                      ""
                    )}
                    {progress >= 25 ? "%" : ""}
                  </div>
                )}
              </div>
              <div className={"cube__side " + bgColor} />
            </div>
          </div>
        </div>
      ) : (
        <p className="unpublished">
          This campaign is unpublished, retired or not a valid St. Jude
          campaign.
        </p>
      )}
    </div>
  );
};

export default inject("overlayStore")(observer(VerticalOverlay3D));
